import type { SVGProps } from 'react';
const DawnFlagBS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BS_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-BS_svg__a)">
      <path fill="#22B7D5" d="M0 16h22v-5.333H0zM0 5.333h22V0H0z" />
      <path fill="url(#dawn-flag-BS_svg__b)" d="M0 10.667h22V5.333H0z" />
      <path fill="#262626" d="m0 0 10.476 8L0 16z" />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-BS_svg__b"
        x1={0}
        x2={0}
        y1={5.333}
        y2={10.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCE569" />
        <stop offset={1} stopColor="#FADF52" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagBS;
